import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import TypesOfColleges from '../../resources/types of colleges.svg';
import TypesOfAdmission from '../../resources/typesofadmission.svg';
import Extracurriculars from '../../resources/Extracurriculars.svg';
import Academics from '../../resources/Academics.svg';
import Essential from '../../resources/Essential.svg';
import FinancialAid from '../../resources/financial aid.svg';
import WhyStudyInUSA from '../../resources/why study in usa.svg';
import admission from '../../resources/admission.svg';
import { MdClose, MdKeyboardArrowDown } from 'react-icons/md';
import { motion, AnimatePresence } from 'framer-motion';

const admissionLinks = [
  { text: 'ليه تدرس في امريكا', img: WhyStudyInUSA },
  { text: 'الشروط الاساسية',    img: Essential },
  { text: 'انواع الجامعات',     img: TypesOfColleges },
  { text: 'الدعم المادي/المنح', img: FinancialAid },
  { text: 'Academics',          img: Academics },
  { text: 'Extracurriculars',   img: Extracurriculars },
  { text: 'انواع التقديم',      img: TypesOfAdmission },
  { text: 'Common App',         img: TypesOfColleges },
];

const extraLinks = [
  { text: 'مكتبة',               key: 'library',  img: admission },
  { text: 'بروجرامز و مسابقات',  key: 'programs', img: admission },
];

function useIsMobile() {
  const [isMobile, setIsMobile] = useState(() => window.innerWidth <= 768);
  useEffect(() => {
    const handler = () => setIsMobile(window.innerWidth <= 768);
    window.addEventListener('resize', handler);
    return () => window.removeEventListener('resize', handler);
  }, []);
  return isMobile;
}

const NavItem = ({ item, isActive, onClick }) => (
  <button
    onClick={onClick}
    className={`w-full flex flex-row-reverse items-center gap-3 px-3 py-2.5 rounded-lg text-right transition-all duration-150 ${
      isActive
        ? 'bg-[#3555C6] text-white'
        : 'text-[#888] hover:text-white hover:bg-white/[0.04]'
    }`}
  >
    <div className={`shrink-0 w-7 h-7 flex items-center justify-center rounded-md transition-colors ${
      isActive ? 'bg-white/20' : 'bg-white/[0.05]'
    }`}>
      <img src={item.img} alt="" className="w-4 h-4 object-contain" draggable={false} />
    </div>
    <span className="text-[13.5px] font-medium flex-1 truncate">{item.text}</span>
    {isActive && <span className="w-1 h-1 rounded-full bg-white shrink-0" />}
  </button>
);

const Divider = ({ label }) => (
  <div className="flex items-center gap-2 px-3 pt-4 pb-1.5">
    <span className="text-[10px] font-semibold uppercase tracking-[0.12em] text-[#3a3a3a]">{label}</span>
    <div className="flex-1 h-px bg-white/[0.04]" />
  </div>
);

const SidebarContent = ({ active, setactive, isMobile, setIsOpen }) => {
  const [admissionOpen, setAdmissionOpen] = useState(true);

  const handleSelect = (key) => {
    setactive(key);
    if (isMobile) setIsOpen(false);
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <div className="flex flex-col h-full">
      {/* Logo area — only shown on mobile (desktop navbar already has the logo) */}
      {isMobile && (
        <div className="px-5 py-5 border-b border-white/[0.05]">
          <Link
            to="/"
            onClick={() => { if (isMobile) setIsOpen(false); }}
            className="block"
          >
            <div className="logo text-right">
              <div style={{ color: '#E0E0E0' }}>Campus</div>
              <div style={{ color: '#3555C6' }}>Odyssey</div>
            </div>
          </Link>
        </div>
      )}
      {/* Desktop top spacing to sit below navbar */}
      {!isMobile && <div className="h-4" />}

      {/* Nav */}
      <nav className="flex-1 overflow-y-auto px-3 py-3 space-y-0.5">

        {/* Admission collapsible */}
        <Divider label="أدمشن" />
        <button
          onClick={() => setAdmissionOpen(v => !v)}
          className="w-full flex flex-row-reverse items-center justify-between px-3 py-2 rounded-lg hover:bg-white/[0.03] transition-colors group"
        >
          <span className="text-[11px] font-semibold uppercase tracking-[0.12em] text-[#444] group-hover:text-[#666] transition-colors">المحتوى</span>
          <MdKeyboardArrowDown
            size={15}
            className={`text-[#444] transition-transform duration-200 ${admissionOpen ? 'rotate-180' : ''}`}
          />
        </button>

        <AnimatePresence initial={false}>
          {admissionOpen && (
            <motion.div
              initial={{ height: 0, opacity: 0 }}
              animate={{ height: 'auto', opacity: 1 }}
              exit={{ height: 0, opacity: 0 }}
              transition={{ duration: 0.2, ease: 'easeInOut' }}
              className="overflow-hidden space-y-0.5"
            >
              {admissionLinks.map((item) => (
                <NavItem
                  key={item.text}
                  item={item}
                  isActive={active === item.text}
                  onClick={() => handleSelect(item.text)}
                />
              ))}
            </motion.div>
          )}
        </AnimatePresence>

        {/* Extra sections */}
        <Divider label="استكشف" />
        {extraLinks.map((item) => (
          <NavItem
            key={item.key}
            item={{ text: item.text, img: item.img }}
            isActive={active === item.key}
            onClick={() => handleSelect(item.key)}
          />
        ))}
      </nav>

      {/* Footer link */}
      <div className="px-5 py-4 border-t border-white/[0.05]">
        <Link
          to="/"
          onClick={() => { if (isMobile) setIsOpen(false); }}
          className="flex flex-row-reverse items-center gap-1.5 text-[12px] text-[#3a3a3a] hover:text-[#777] transition-colors"
        >
          <span className="text-[10px]">→</span>
          <span>العودة للرئيسية</span>
        </Link>
      </div>
    </div>
  );
};

export default function Sidebar(props) {
  const isMobile = useIsMobile();

  return (
    <>
      {/* Mobile: slide-in panel from right */}
      <AnimatePresence>
        {isMobile && props.isopen && (
          <>
            <motion.div
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              exit={{ opacity: 0 }}
              transition={{ duration: 0.2 }}
              className="fixed inset-0 bg-black/50 z-[90]"
              onClick={() => props.setIsOpen(false)}
            />
            <motion.div
              initial={{ x: '100%' }}
              animate={{ x: 0 }}
              exit={{ x: '100%' }}
              transition={{ type: 'tween', duration: 0.28, ease: [0.32, 0, 0.18, 1] }}
              className="fixed top-0 right-0 h-full w-[270px] bg-[#0A0A0A] border-l border-white/[0.06] z-[100] shadow-2xl"
            >
              <button
                onClick={() => props.setIsOpen(false)}
                className="absolute top-4 left-4 w-8 h-8 flex items-center justify-center rounded-lg bg-white/[0.07] hover:bg-white/[0.12] transition-colors text-white z-10"
                aria-label="إغلاق"
              >
                <MdClose size={16} />
              </button>
              <SidebarContent
                active={props.active}
                setactive={props.setactive}
                isMobile={isMobile}
                setIsOpen={props.setIsOpen}
              />
            </motion.div>
          </>
        )}
      </AnimatePresence>

      {/* Desktop: fixed sidebar */}
      {!isMobile && (
        <div className="fixed top-[72px] right-0 h-[calc(100vh-72px)] w-64 bg-[#0A0A0A] border-l border-white/[0.05] z-50 overflow-hidden">
          <SidebarContent
            active={props.active}
            setactive={props.setactive}
            isMobile={false}
            setIsOpen={props.setIsOpen}
          />
        </div>
      )}
    </>
  );
}
